import { get, post, put } from "./api_helper"

const getIgarashiInfo = () => get(`igarashi-company`)


const CommonAPI = {
  getIgarashiInfo
}

export default CommonAPI